import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);

  const login = () => {
    localStorage.setItem('isAuthenticated', 'true');
    Cookies.set('authToken', 'your-auth-token-value', { expires: 7 }); // Set the authToken cookie, with a 7-day expiration
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('isAuthenticated');
    Cookies.remove('authToken');
    Cookies.remove('userRole');  // Remove the authToken cookie
      // Remove the authToken cookie
    setIsAuthenticated(false);
    window.location.pathname = "/login";
  };

  return { isAuthenticated, login, logout };
};

export default useAuth;
